import * as Immutable from "immutable";
import HighlightingRule from "./highlighting/HighlightingRule";
export default class FormattingSettings {
  constructor(highlighting = []) {
    this._value = { highlighting };
  }
  get highlighting() {
    return this._value.highlighting;
  }
  toBuilder() {
    const { highlighting } = this._value;
    return new Builder(Immutable.Map({ highlighting }));
  }
  static create(highlighting) {
    return new FormattingSettings(highlighting);
  }
  static empty() {
    return new Builder().build();
  }
  toJSON() {
    const { highlighting } = this._value;
    return {
      highlighting
    };
  }
  static fromJSON(value) {
    const { highlighting = [] } = value;
    return FormattingSettings.create(highlighting.map((rule) => HighlightingRule.fromJSON(rule)));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  highlighting(value) {
    return new Builder(this.value.set("highlighting", value));
  }
  build() {
    const { highlighting } = this.value.toObject();
    return new FormattingSettings(highlighting);
  }
}
